import React from "react";

export const ResizeHandle = () => {
    return (
        <svg width="18" height="8" viewBox="0 0 18 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_47_13061)">
                <path d="M1 7H17" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M1 1H17" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_47_13061">
                    <rect width="18" height="8" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
